module.exports = (__webpack_require__(68455))(2350);